import { compact } from '.'

const formatLocation = (
  city?: string,
  state?: string,
  fallbackMessage: string = 'Location Unknown',
) => compact(city, state).join(', ') || fallbackMessage

export default formatLocation
